import { LocalizationKeys } from '../models/localizationKeys';
export var getDefaultTranslations = function getDefaultTranslations() {
  var translationValues = Object.values(LocalizationKeys);
  var defaultTranslations = {};
  translationValues.forEach(function (value) {
    return defaultTranslations[value.id] = value.defaultMessage;
  });
  return defaultTranslations;
};